export const arrayToOrderedHashmap = <T>(
  items: Array<T>
): Record<number, T> => {
  return items.reduce((hashmap, item, idx) => {
    hashmap[idx] = item
    return hashmap
  }, {})
}
